import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance13ujfby7pfhe7 as Companion_getInstance,
  toLocalDateTime2fafgh396r2y5 as toLocalDateTime,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { renderToString20fhv3rgk9b94 as renderToString } from './LocalTimeRender.js.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function renderToString_0(_this__u8e3s4, size, zone, includeWeekday, includeYear, includeEra) {
  size = size === VOID ? RenderSize_Full_getInstance() : size;
  zone = zone === VOID ? Companion_getInstance().currentSystemDefault_9rduv_k$() : zone;
  includeWeekday = includeWeekday === VOID ? false : includeWeekday;
  includeYear = includeYear === VOID ? true : includeYear;
  includeEra = includeEra === VOID ? false : includeEra;
  return renderToString(toLocalDateTime(_this__u8e3s4, zone), size, includeWeekday, includeYear, includeEra);
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  RenderSize_Numerical_instance = new (RenderSize())('Numerical', 0);
  RenderSize_Abbreviation_instance = new (RenderSize())('Abbreviation', 1);
  RenderSize_Full_instance = new (RenderSize())('Full', 2);
}
var RenderSize_Numerical_instance;
var RenderSize_Abbreviation_instance;
var RenderSize_Full_instance;
var RenderSizeClass;
function RenderSize() {
  if (RenderSizeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'RenderSize');
    RenderSizeClass = $;
  }
  return RenderSizeClass;
}
function RenderSize_Abbreviation_getInstance() {
  static_init();
  return RenderSize_Abbreviation_instance;
}
function RenderSize_Full_getInstance() {
  static_init();
  return RenderSize_Full_instance;
}
//region block: exports
export {
  renderToString_0 as renderToStringprxvmjepz2st,
  RenderSize_Abbreviation_getInstance as RenderSize_Abbreviation_getInstance3svlv9et1kjyg,
  RenderSize_Full_getInstance as RenderSize_Full_getInstance276lrvq07dtkk,
};
//endregion

//# sourceMappingURL=LocalTimeRender.mjs.map
